export function buildBreadcrumbs({
  path,
  additionalCrumbs = [],
  breadcrumb = {},
  workCenterUuid,
  workCenterName,
}) {
  const routeSegments = path.split('/').filter(Boolean);
  const segments = [...routeSegments, ...additionalCrumbs];
  const routeLeafIndex = routeSegments.length - 1;
  const crumbs = [];
  let href = '';

  segments.forEach((segment, index) => {
    if (index === routeLeafIndex) {
      for (const parent of breadcrumb.parents ?? []) {
        crumbs.push({
          href: href || '/',
          active: false,
          key: parent.key,
          disabled: parent.disabled ?? true,
        });
      }
    }

    href = `${href}/${segment}`;
    const isRouteLeaf = index === routeLeafIndex;
    const key =
      isRouteLeaf && breadcrumb.leafKey
        ? breadcrumb.leafKey
        : segment === workCenterUuid
        ? workCenterName
        : segment;

    crumbs.push({
      href,
      active: index === segments.length - 1,
      key,
      ...(isRouteLeaf && breadcrumb.leafTranslationKey
        ? { translationKey: breadcrumb.leafTranslationKey }
        : {}),
    });
  });

  return crumbs;
}
